import React, { Component } from 'react';
import Cache from '../../libs/Cache';
import { invokeApig } from '../../libs/awsLib';
import { Dropdown, Button } from 'semantic-ui-react';
import { isValidUUID } from '../../libs/isValidUUIDUtility';
import AssignmentWithRemoval from './AssignmentWithRemoval';
import '../Demographics/index.css';

export default class Assignment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: this.props.username,
      entityId: parseInt(this.props.entityId, 10),
      admissionId: this.props.admissionId,
      patientId: this.props.patientId,
      assignedUser: this.props.assignedUser,
      isTeamLead: this.props.isTeamLead,
      isManualReviewType: this.props.isManualReviewType,
      isInternalSysAdmin: this.props.isInternalSysAdmin,
      isExternalAdmin: this.props.isExternalAdmin,
      isPAUser: this.props.isPAUser,
      hasOpenPaReview: this.props.hasOpenPaReview,
      patientName: this.props.patientName,
      reviewers: [],
    };

    if (this.props.assignedUser) {
      this.state.assignedUser = this.props.assignedUser;
    }

    if (this.props.assignmentCompleted) {
      this.state.assignmentCompleted = this.props.assignmentCompleted;
    }

    if (this.props.style) {
      this.state.style = this.props.style;
    }

    if (this.props.className) {
      this.state.className = this.props.className;
    }

    if (this.props.size) {
      this.state.size = this.props.size;
    }

    if (this.props.reviewers) {
      this.state.reviewers = this.props.reviewers;
    }

    if (this.props.showLabel) {
      this.state.showLabel = this.props.showLabel;
    }

    // handle case where user is not a reviewer
    if (
      this.state.reviewers.filter((r) => r.username === this.state.username)
        .length === 0
    ) {
      this.state.userIsNotAReviewer = true;
    } else if (
      this.state.assignedUser &&
      this.state.assignedUser !== 'Unassigned'
    ) {
      // handle case where this is assigned to another team that shares
      // facilities with user.
      if (
        this.state.reviewers.filter(
          (r) => r.username === this.state.assignedUser
        ).length === 0
      ) {
        this.state.assignedToAnotherTeam = true;
      }
    }

    this.cache = new Cache(this.props.userToken);
    this.handleTeammateChange = this.handleTeammateChange.bind(this);
    this.handleUnassign = this.handleUnassign.bind(this);
    this.handleAssign = this.handleAssign.bind(this);
  }

  static getDerivedStateFromProps(nextProps, state) {
    const newState = {};
    newState.assignedUser = nextProps.assignedUser;
    newState.entityId = nextProps.entityId;
    newState.admissionId = nextProps.admissionId;
    newState.patientId = nextProps.patientId;
    newState.isTeamLead = nextProps.isTeamLead;
    newState.isManualReviewType = nextProps.isManualReviewType;
    newState.isInternalSysAdmin = nextProps.isInternalSysAdmin;
    newState.isExternalAdmin = nextProps.isExternalAdmin;
    newState.isPAUser = nextProps.isPAUser;
    newState.hasOpenPaReview = nextProps.hasOpenPaReview;
    newState.patientName = nextProps.patientName;
    newState.assignmentCompleted = nextProps.assignmentCompleted;
    newState.style = nextProps.style;
    newState.className = nextProps.className;
    newState.size = nextProps.size;
    newState.assignedToAnotherTeam = false;

    // handle case where user is not a reviewer
    if (
      state.reviewers.filter((r) => r.username === state.username).length === 0
    ) {
      newState.userIsNotAReviewer = true;
    } else if (
      newState.assignedUser &&
      newState.assignedUser !== 'Unassigned'
    ) {
      // handle case where this is assigned to another team that shares
      // facilities with user.
      if (
        state.reviewers.filter((r) => r.username === newState.assignedUser)
          .length === 0
      ) {
        newState.assignedToAnotherTeam = true;
      }
    }

    return newState;
  }

  buildReviewersDropDownListItems() {
    const reviewers = this.state.reviewers.filter(
      (reviewer) => reviewer.enabled
    );
    const selectableReviewers = [];

    if (!reviewers || reviewers.length === 0) {
      return selectableReviewers;
    }

    const entityId = this.state.entityId;

    if (isValidUUID(this.state.admissionId)) {
      reviewers
        .filter((r) => r.entities.filter((id) => id === entityId).length > 0)
        .forEach((value, index) => {
          selectableReviewers.push({
            key: value.username,
            text: value.first_name + ' ' + value.last_name,
            'data-username': value.username,
            value: value.username,
          });
        });
    } else {
      reviewers
        .filter(
          (r) =>
            r.entities.filter((id) => id === parseInt(entityId, 10)).length > 0
        )
        .forEach((value, index) => {
          selectableReviewers.push({
            key: value.username,
            text: value.first_name + ' ' + value.last_name,
            'data-username': value.username,
            value: value.username,
          });
        });
    }

    selectableReviewers.sort((a, b) => {
      return a.text.localeCompare(b.text);
    });

    if (!this.state.userIsNotAReviewer) {
      selectableReviewers.unshift({
        key: 'ASSIGN TO ME',
        text: 'ASSIGN TO ME',
        value: 'ASSIGN TO ME',
        'data-username': 'ASSIGN TO ME',
      });
    }

    selectableReviewers.unshift({
      key: 'Unassigned',
      text: 'Unassigned',
      value: 'Unassigned',
      'data-username': 'Unassigned',
    });

    if (
      (this.state.isInternalSysAdmin ||
        this.state.isExternalAdmin ||
        this.state.isPAUser) &&
      this.state.isManualReviewType &&
      !this.state.hasOpenPaReview
    ) {
      selectableReviewers.unshift({
        key: 'Remove Patient Encounter',
        text: 'Remove Patient Encounter',
        value: 'Remove Patient Encounter',
        'data-username': 'Remove Patient Encounter',
      });
    }

    return selectableReviewers;
  }

  buildPADropDownListItems() {
    const selectableOptions = [];

    if (this.state.username === this.state.assignedUser) {
      const reviewers = this.state.reviewers.filter(
        (reviewer) => reviewer.enabled
      );
      const reviewerObject = reviewers.find((reviewer) => {
        return reviewer.username === this.state.username;
      });

      if (reviewerObject && reviewerObject.id) {
        selectableOptions.push({
          key: this.state.username,
          text: `${reviewerObject.first_name} ${reviewerObject.last_name}`,
          value: this.state.username,
          'data-username': this.state.username,
        });
      }

      selectableOptions.push({
        key: 'Unassigned',
        text: 'Unassigned',
        value: 'Unassigned',
        'data-username': 'Unassigned',
      });
    } else {
      selectableOptions.push({
        key: 'ASSIGN TO ME',
        text: 'ASSIGN TO ME',
        value: 'ASSIGN TO ME',
        'data-username': 'ASSIGN TO ME',
      });
    }

    selectableOptions.push({
      key: 'Remove Patient Encounter',
      text: 'Remove Patient Encounter',
      value: 'Remove Patient Encounter',
      'data-username': 'Remove Patient Encounter',
    });

    return selectableOptions;
  }

  async handleTeammateChange(event, data) {
    if (data.value === '') {
      return;
    }

    const prevUsername = this.state.assignedUser;
    const username = data.value;
    const entityid = this.state.entityId;
    const admissionid = this.state.admissionId;
    const patientid = this.state.patientId;
    const queue = this.props.queueState ? this.props.queueState.queue : [];
    const queueAdmissions = [];
    queue &&
      queue.forEach((admission, index) => {
        queueAdmissions.push(admission.admission_id);
      });

    // there was no change
    if (username === prevUsername) {
      return;
    }

    try {
      if (username === 'Unassigned') {
        if (this.state.assignmentCompleted) {
          this.state.assignmentCompleted(
            {
              entityId: entityid,
              admissionId: admissionid,
              assignedUser: null,
            },
            null
          );
        }
        this.setState({ assignedUser: null });
        if (prevUsername) {
          await this.unassign(prevUsername, entityid, admissionid);
        }
      } else if (username === 'ASSIGN TO ME') {
        if (this.state.assignmentCompleted) {
          this.state.assignmentCompleted(
            {
              entityId: entityid,
              admissionId: admissionid,
              assignedUser: this.props.username,
            },
            null
          );
        }
        this.setState({ assignedUser: this.props.username });
        await this.assign(
          prevUsername,
          this.props.username,
          entityid,
          admissionid,
          patientid
        );
        if (queueAdmissions.length && !queueAdmissions.includes(admissionid)) {
          await this.props.fetchQueue();
        }
      } else if (username === 'Remove Patient Encounter') {
        if (this.state.assignmentCompleted) {
          this.state.assignmentCompleted(
            {
              entityId: entityid,
              admissionId: admissionid,
              assignedUser: username,
            },
            null
          );
        }
        this.removePatientEncounter(
          entityid,
          admissionid,
          patientid,
          this.state.assignedUser
        );
      } else {
        if (this.state.assignmentCompleted) {
          this.state.assignmentCompleted(
            {
              entityId: entityid,
              admissionId: admissionid,
              assignedUser: username,
            },
            null
          );
        }
        this.setState({ assignedUser: username });
        await this.assign(
          prevUsername,
          username,
          entityid,
          admissionid,
          patientid
        );
        if (queueAdmissions.length && !queueAdmissions.includes(admissionid)) {
          await this.props.fetchQueue();
        }
      }
    } catch (error) {
      console.log(error);
      if (this.state.assignmentCompleted) {
        this.state.assignmentCompleted(null, {
          message: JSON.parse(error.message),
        });
      }
    }
  }

  async handleUnassign() {
    const entityid = this.state.entityId;
    const admissionid = this.state.admissionId;

    try {
      this.unassign(this.state.assignedUser, entityid, admissionid);

      if (this.state.assignmentCompleted) {
        this.state.assignmentCompleted(
          { entityId: entityid, admissionId: admissionid, assignedUser: null },
          null
        );
      }

      this.setState({ assignedUser: '' });
    } catch (error) {
      console.log(error);
      if (this.state.assignmentCompleted) {
        this.state.assignmentCompleted(null, {
          message: JSON.parse(error.message).err,
        });
      }
    }
  }

  async handleAssign() {
    const prevUsername = this.state.assignedUser;
    const username = this.state.username;
    const entityid = this.state.entityId;
    const admissionid = this.state.admissionId;
    const patientid = this.state.patientId;
    const queue = this.props.queueState ? this.props.queueState.queue : [];
    const queueAdmissions = [];
    queue &&
      queue.forEach((admission, index) => {
        queueAdmissions.push(admission.admission_id);
      });

    try {
      if (this.state.assignmentCompleted) {
        this.state.assignmentCompleted(
          {
            entityId: entityid,
            admissionId: admissionid,
            assignedUser: username,
          },
          null
        );
      }
      this.setState({ assignedUser: username });
      await this.assign(
        prevUsername,
        username,
        entityid,
        admissionid,
        patientid
      );
      if (queueAdmissions.length && !queueAdmissions.includes(admissionid)) {
        await this.props.fetchQueue();
      }
    } catch (error) {
      console.log(error);
      if (this.state.assignmentCompleted) {
        this.state.assignmentCompleted(null, {
          message: JSON.parse(error.message).err,
        });
      }
    }
  }

  assign(prevUsername, username, entityid, admissionid, patientid) {
    // FEATURE FLAG - includesEventQueue
    if (isValidUUID(entityid) && isValidUUID(admissionid)) {
      return invokeApig(
        {
          service: 'PATIENT_QUEUE',
          path: '/patient-event-queue/assign',
          method: 'POST',
          body: {
            entity_id: entityid,
            admission_id: admissionid,
            xpas_username: username,
            prev_username: prevUsername,
          },
        },
        this.props.userToken
      );
    } else {
      return invokeApig(
        {
          service: 'PATIENT_QUEUE',
          path: '/patient-queue/assign',
          method: 'POST',
          body: {
            entity_id: entityid,
            admission_id: admissionid,
            xpas_username: username,
            patient_id: patientid,
          },
        },
        this.props.userToken
      );
    }
  }

  unassign(username, entityid, admissionid) {
    if (isValidUUID(entityid) && isValidUUID(admissionid)) {
      return invokeApig(
        {
          service: 'PATIENT_QUEUE',
          path: '/patient-event-queue/unassign',
          method: 'PUT',
          body: {
            entity_id: entityid,
            admission_id: admissionid,
            xpas_username: username,
          },
        },
        this.props.userToken
      );
    } else {
      return invokeApig(
        {
          service: 'PATIENT_QUEUE',
          path: '/patient-queue/unassign',
          method: 'PUT',
          body: {
            entity_id: entityid,
            admission_id: admissionid,
            xpas_username: username,
          },
        },
        this.props.userToken
      );
    }
  }

  removePatientEncounter(entityid, admissionid, patientid, username) {
    if (isValidUUID(entityid) && isValidUUID(admissionid)) {
      return invokeApig(
        {
          service: 'PATIENT_QUEUE',
          path: '/patient-event-queue/remove-encounter',
          method: 'PUT',
          body: {
            entity_id: entityid,
            admission_id: admissionid,
            xpas_username: username,
          },
        },
        this.props.userToken
      );
    } else {
      return invokeApig(
        {
          service: 'PATIENT_QUEUE',
          path: '/patient-queue/remove-encounter',
          method: 'PUT',
          body: {
            entity_id: entityid,
            admission_id: admissionid,
            patient_id: patientid,
            xpas_username: username,
          },
        },
        this.props.userToken
      );
    }
  }

  render() {
    if (
      this.state.assignedToAnotherTeam ||
      (!this.state.assignedUser && this.props.isAssignedToXsolisInternalPa)
    ) {
      return this.renderAssignedToAnotherTeam();
    }

    if (
      this.state.isInternalSysAdmin ||
      this.state.isExternalAdmin ||
      (this.state.isTeamLead &&
        this.state.isPAUser &&
        !this.state.userIsNotAReviewer)
    ) {
      return this.renderAssignmentWithRemovalOption();
    }

    if (this.state.isTeamLead && !this.state.userIsNotAReviewer) {
      return this.renderTeamLead();
    }

    if (this.state.userIsNotAReviewer) {
      return this.renderUnableToDoReviews();
    }

    if (this.state.isPAUser) {
      return this.renderPAOptions();
    }

    if (this.state.username === this.state.assignedUser) {
      return this.renderInAssignedState();
    }

    if (
      !this.state.assignedUser ||
      this.state.assignedUser === '' ||
      this.state.assignedUser === 'Unassigned'
    ) {
      return this.renderInAssignableState();
    }

    return this.renderInUnassignableState();
  }

  renderUnableToDoReviews() {
    if (!this.state.assignedUser || !this.state.reviewers) {
      return <span></span>;
    }

    const reviewer = this.state.reviewers.find(
      (r) => r.username === this.state.assignedUser
    );

    if (!reviewer) {
      return <span>{this.state.assignedUser}</span>;
    }

    return (
      <span>
        {reviewer.first_name} {reviewer.last_name}
      </span>
    );
  }

  renderAssignedToAnotherTeam() {
    const style = {};

    if (this.state.showLabel) {
      style.paddingRight = '5px';
    }

    return (
      <strong className='grid-element' style={style}>
        {this.props.isAssignedToXsolisInternalPa
          ? 'XSOLIS PA Services'
          : 'Assigned To Another Team'}
      </strong>
    );
  }

  renderTeamLead() {
    const options = this.buildReviewersDropDownListItems();

    if (this.state.assignedUser && options) {
      if (!options.find((option) => option.value === this.state.assignedUser)) {
        return this.renderAssignedToAnotherTeam();
      }
    }

    //this drop down shows on patient details
    if (this.state.showLabel) {
      return (
        <span>
          <span
            style={{ color: '#5F6E77', fontSize: '14px', marginRight: '8px' }}
          >
            Assigned To:{' '}
          </span>
          <Dropdown
            options={options}
            className='cb-assignment'
            id='dropdownStyle'
            data-entity-id={this.state.entityId}
            data-admission-id={this.state.admissionId}
            placeholder='Assign To'
            selection
            value={this.state.assignedUser ? this.state.assignedUser : ''}
            onChange={this.handleTeammateChange}
            selectOnBlur={false}
          />
        </span>
      );
    }

    // this dropdown shows on the work queue
    return (
      <Dropdown
        options={options}
        className='cb-assignment'
        data-entity-id={this.state.entityId}
        data-admission-id={this.state.admissionId}
        placeholder='Assign To'
        selection
        value={this.state.assignedUser ? this.state.assignedUser : ''}
        onChange={this.handleTeammateChange}
        fluid
        selectOnBlur={false}
      />
    );
  }

  renderAssignmentWithRemovalOption() {
    const options = this.buildReviewersDropDownListItems();

    if (this.state.assignedUser && options) {
      if (!options.find((option) => option.value === this.state.assignedUser)) {
        return this.renderAssignedToAnotherTeam();
      }
    }

    return (
      <AssignmentWithRemoval
        options={options}
        showLabel={this.state.showLabel}
        entityId={this.state.entityId}
        admissionId={this.state.admissionId}
        assignedUser={this.state.assignedUser}
        style={this.state.style}
        handleTeammateChange={this.handleTeammateChange}
        patientName={this.state.patientName}
        queueState={this.props.queueState}
        setQueueState={this.props.setQueueState}
      />
    );
  }

  renderPAOptions() {
    const isUnassigned =
      !this.state.assignedUser || this.state.assignedUser === 'Unassigned';
    const isAssignedToOtherUser =
      !isUnassigned && this.state.assignedUser !== this.state.username;
    if (
      this.state.isManualReviewType &&
      !this.state.hasOpenPaReview &&
      !isAssignedToOtherUser
    ) {
      const options = this.buildPADropDownListItems();

      return (
        <AssignmentWithRemoval
          options={options}
          showLabel={this.state.showLabel}
          entityId={this.state.entityId}
          admissionId={this.state.admissionId}
          assignedUser={this.state.assignedUser}
          style={this.state.style}
          handleTeammateChange={this.handleTeammateChange}
          patientName={this.state.patientName}
          queueState={this.props.queueState}
          setQueueState={this.props.setQueueState}
        />
      );
    }

    if (this.state.username === this.state.assignedUser) {
      return this.renderInAssignedState();
    }

    if (
      !this.state.assignedUser ||
      this.state.assignedUser === '' ||
      this.state.assignedUser === 'Unassigned'
    ) {
      return this.renderInAssignableState();
    }

    return this.renderInUnassignableState();
  }

  //buttons are used on Patient Details and Patient Work Queue
  renderInAssignedState() {
    return (
      <Button
        onClick={this.handleUnassign}
        data-entity-id={this.state.entityId}
        data-admission-id={this.state.admissionId}
        size={this.state.size ? this.state.size : 'mini'}
        id='unassignBtn'
      >
        UNASSIGN
      </Button>
    );
  }

  renderInAssignableState() {
    return (
      <Button
        onClick={this.handleAssign}
        data-entity-id={this.state.entityId}
        data-admission-id={this.state.admissionId}
        size={this.state.size ? this.state.size : 'mini'}
        id='AssignBtn'
      >
        ASSIGN TO ME
      </Button>
    );
  }

  renderInUnassignableState() {
    let userName = this.state.assignedUser;

    const reviewerMatch = this.state.reviewers.filter(
      (r) => r.username === this.state.assignedUser
    );

    if (reviewerMatch && reviewerMatch.length > 0) {
      userName = `${reviewerMatch[0].first_name} ${reviewerMatch[0].last_name}`;
    }

    if (this.state.showLabel) {
      return (
        <span
          style={{ color: '#5F6E77', fontSize: '14px', marginRight: '8px' }}
        >
          <span className='lbl-assigned-to'>Assigned To: </span>
          {userName}
        </span>
      );
    }

    return <span>{userName}</span>;
  }
}
